import React, {useState} from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    SelectChangeEvent,
    Grid,
    Stack,
    Autocomplete,
    TextField
} from "@mui/material";
import {styles} from "common/inputStyles";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface MuiSelectProps {
    label?: string;
    sKey: string;
    value: string;
    selectedValue?: any
    dataSource: any;
    mandatory:boolean;
    iserror:boolean
    onChangeHandler?: any;
    disabled?:boolean
}


const TruckMuiSelect: React.FC<MuiSelectProps> = ({label, sKey, value, selectedValue, dataSource,mandatory,iserror,onChangeHandler,disabled}) => {

    const defaultProps = {
        options: dataSource,
        getOptionLabel: (option:any) => option[value]?option[value]:"",
    };
   // console.log(selectedValue);
    return (
        <FormControl fullWidth size="small" required={true}>
            <Autocomplete aria-required={true}
                          disablePortal
                          {...defaultProps}
                          id="combo-box-demo"
                          options={dataSource}
                          value={selectedValue?selectedValue:""}
                          onChange={(event, newValue) => {
                              onChangeHandler(newValue);
                              //setValue(newValue);
                          }}
                          disabled={disabled}

                          renderInput={(params) => <TextField {...params} label={label} error={iserror} required={mandatory}/>}
            />
        </FormControl>

    )
}

export default TruckMuiSelect;
